import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Search from './Search.js'

// import search from '../assets/Search.svg';
import favourite from '../assets/Favourite.svg';
import dropDown from '../assets/dropDown.svg';
import back from '../assets/Back.svg';
import note from '../assets/Note.svg';

export default function Molecule() {

    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [moleculeItems, setMoleculeItems] = useState([]);
    const [moleculeFavouriteItem, setMoleculeFavouriteItem] = useState([]);
    const userId = sessionStorage.getItem('userId');

    // const favouriteItems = [{ type: 'Molecule', item: 'Azithromycin Dihydrate', id: 1 }, { type: 'Molecule', item: 'Brinzolamide', id: 2 }, { type: 'Molecule', item: 'Carboxymethyl Cellulose (CMC)', id: 3 }];

    useEffect(() => {
        const apiUrl = `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/molecules?userId=${userId}`;

        // Fetching data
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setMoleculeItems(data.molecules)
            })
            .catch((error) => {
                // setError(error.message);  // Handle any errors
                // setLoading(false);
                console.log(error);

            });
    }, []);

    useEffect(() => {
        const apiUrl = `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/favourites/${userId}?type=molecules`;

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Networkresponse was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setMoleculeFavouriteItem(data.data);
            }).catch(error => {
                console.log(error);
            })
    }, []);

    const handleSearch = useCallback(async (query) => {
        if (query.length === 0) {
            setSearchResults([]);
            setIsSearching(false);

            return;
        }
        setIsSearching(true);
        try {
            // const response = await fetch("https://alembicdigilabs.in/medicaldictionary/v1/eyecare/keyword-search", {
            const response = await fetch(`https://alembicdigilabs.in/medicaldictionary/v1/eyecare/search?query=${query}&userId=${userId}`, {
                // method: "POST",
                method: "GET",
                headers: {
                    'authorization': `bearer ${sessionStorage.getItem('token')}`
                },
                // body: JSON.stringify(querry),
            }); // Fetch from public folder
            const data = await response.json();

            // Filter results based on query
            // const filteredResults = data.results.filter(item =>
            //     item.name.toLowerCase().includes(query.toLowerCase())
            // );
            setSearchResults(data.results.molecules);
        } catch (error) {
            console.error("Error fetching search results:", error);
        }
    }, []);

    return (
        <div className="dictionary-container">
            {/* Header */}
            <header className="text-left py-3 d-flex gap-3">
                <Link to="/dictionary" className="text-decoration-none align-self-center">
                    <img src={back} alt="Back" className="dictionary-icon mb-3" />
                </Link>
                <p className='dictionaryHeader'>Molecule</p>
            </header>


            {/* Search Bar */}
            <Search onSearch={handleSearch} />

            {isSearching ? (
                <div className="mt-3">
                    {searchResults.length > 0 ? (
                        <ul className="list-group">
                            {searchResults.map((item, index) => (
                                <li key={index} className="list-group-item">
                                    <Link to={`/moleculeDetails/${item.id}`} className="text-decoration-none text-secondary"
                                        state={{ from: "/molecule", moleculeDetails: item, isFavorite: item.favourite }}>
                                        {item.Molecule_Name} {/* Adjust based on API response */}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted">No results found</p>
                    )}
                </div>
            ) : (<>


                {/* Your Favourite Section */}
                {moleculeFavouriteItem !== 0 && (
                    <div className="favourite-section">
                        <div className='favourite-header'>
                            <img src={favourite} alt="Card 2" className="" />
                            <p>Your Favourite</p>
                        </div>
                        <ul className="favourite-list">
                            {moleculeFavouriteItem.map((item, index) => (
                                <li key={index} className="favourite-item">
                                    <Link to={`/moleculeDetails/${item.id}`} className="text-decoration-none text-secondary"
                                        state={{ from: "/molecule", moleculeDetails: item, isFavorite: true }}>
                                        {item.Molecule_Name}
                                    </Link>
                                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                        <div className='type-container'>
                                            <span className={`favourite-type blue`}>{item.Type}</span>
                                        </div>
                                        <img src={dropDown} alt="Dropdown" className="dropdown-icon" />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}


                {/* Molecule Section */}
                <div className="favourite-section">
                    <div className='favourite-header'>
                        <img src={note} alt="Card 2" className="" />
                        <p>Molecule List</p>
                    </div>
                    <ul className="favourite-list">
                        {moleculeItems.map((item, index) => (
                            <li key={index} className="favourite-item">
                                <Link to={`/moleculeDetails/${item.id}`} className="text-decoration-none text-secondary"
                                    state={{ from: "/molecule", moleculeDetails: item, isFavorite: item.favourite }}>
                                    {item.Molecule_Name}
                                </Link>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <div className='type-container'>
                                        <span className={`favourite-type blue`}>Molecule</span>
                                    </div>
                                    <img src={dropDown} alt="Dropdown" className="dropdown-icon" />
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </>)}
        </div>
    );
}
